export const DownloadIcon = () => {
  return (
    <svg
      id="surface1"
      xmlns="http://www.w3.org/2000/svg"
      width="21.617"
      height="23.966"
      viewBox="0 0 21.617 23.966"
    >
      <path
        id="Path_24419"
        data-name="Path 24419"
        d="M237.853,18.217H240.5l-4.049-4.26v2.851A1.409,1.409,0,0,0,237.853,18.217Zm0,0"
        transform="translate(-225.381 -13.304)"
        fill="#3b4046"
      />
      <path
        id="Path_24420"
        data-name="Path 24420"
        d="M192.612,236.336a6.452,6.452,0,1,0,6.452,6.452A6.458,6.458,0,0,0,192.612,236.336Zm3.466,7-3.164,3.4a.432.432,0,0,1-.319.135.42.42,0,0,1-.313-.135l-3.158-3.4a.434.434,0,0,1,.022-.61.44.44,0,0,1,.615.022l2.419,2.591V239.17a.432.432,0,0,1,.864,0v6.171l2.408-2.591a.43.43,0,1,1,.626.589Zm0,0"
        transform="translate(-177.446 -225.273)"
        fill="#3b4046"
      />
      <path
        id="Path_24421"
        data-name="Path 24421"
        d="M8.082,15.657H3.39a.432.432,0,1,1,0-.864H8.368a7.669,7.669,0,0,1,1.1-1.89H3.39a.432.432,0,0,1,0-.864h6.895a7.433,7.433,0,0,1,4.886-1.857c.178,0,.324.016.54.032V5.777H12.471A2.275,2.275,0,0,1,10.2,3.5V0H1.922A1.932,1.932,0,0,0,0,1.949V18.427a1.914,1.914,0,0,0,1.922,1.927H8.428a7.374,7.374,0,0,1-.345-4.7ZM3.39,9.34H8.86a.432.432,0,0,1,0,.864H3.39a.432.432,0,0,1,0-.864Zm0,0"
        fill="#3b4046"
      />
    </svg>
  );
};
